import { usePageDrawer } from '@app/components/page/drawer/PageDrawerContext';
import { useActiveStation } from '../../../../../../../core/stations/hooks/useActiveStation';
import { useFragmentCreationStore } from '../../../../../../fragments/stores/fragment-creation.store';

export function useOpenFragmentDrawer(): () => void {
  const station = useActiveStation();
  const { openDrawer } = usePageDrawer();

  const openFragmentDrawer = () => {
    const stationId = station.id;
    openDrawer('create-fragment', () =>
      useFragmentCreationStore.getState().clearFormValues(stationId),
    );
  };

  return openFragmentDrawer;
}
